"use strict";

import gsap from "gsap";
import { CSSRulePlugin, CustomEase } from "gsap/all";

const contactAnimation = function (a) {
	gsap.registerPlugin(CSSRulePlugin);

	const tl = gsap.timeline({
		defaults: {
			duration: 1,
			ease: CustomEase.create("custom", "M0,0 C0.199,1.03 0.697,0.969 1,1 "),
		},
	});
	const bgd = CSSRulePlugin.getRule(".section__contact::before");

	const vw = window.innerWidth;
	const vh = window.innerHeight;
	const factor = vw > vh ? (vw * 2.5) / 100 : (vh * 2.5) / 100;

	if (a) {
		tl.to("body", { overflow: "hidden", duration: 0.01 })
			.to(".section__contact", { "z-index": 100000, duration: 0.1 }, "<")
			.to(
				bgd,
				{
					scale: factor,
					ease: CustomEase.create("custom", "M0,0 C0.199,1.03 0.697,0.969 1,1 "),
				},
				"<"
			)
			.to(bgd, { opacity: 1, duration: 0.1, ease: "none" }, "<")
			.to(".section__contact h1", { yPercent: 0, opacity: 1 }, "-=1")
			.to(".section__contact .copy", { y: 0, opacity: 1 }, "<0.2")
			.to(".section__contact #close", { opacity: 1 }, "-=0.5")
			.to(".section__contact .socials", { y: 0, opacity: 1 }, "-=1.4")
			.to(".section__contact .email", { y: 0, opacity: 1 }, "-=1.3");
	} else {
		tl.to(".section__contact .email", { y: -150 })
			.to(".section__contact .email", { opacity: 0, duration: 0.3 }, "<")
			.to(".section__contact .socials", { y: -200 }, "-=0.9")
			.to(".section__contact .socials", { opacity: 0, duration: 0.3 }, "<")
			.to(".section__contact h1", { yPercent: -60 }, "-=1")
			.to(".section__contact h1", { opacity: 0, duration: 0.3 }, "<")
			.to(".section__contact .copy", { y: -300 }, "-=0.9")
			.to(".section__contact .copy", { opacity: 0, duration: 0.3 }, "<")
			.to(".section__contact #close", { opacity: 0 }, "-=1")
			.to(
				bgd,
				{
					scale: 0,
					duration: 0.6,
					ease: CustomEase.create("custom", "M0,0 C0.199,1.03 0.697,0.969 1,1 "),
				},
				"-=1"
			)
			.to(bgd, { opacity: 0, duration: 0.2, ease: "none" }, "<0.2")
			.to(".section__contact", { "z-index": -100, duration: 0.1 }, "-=0.5")
			.to("body", { overflow: "initial", duration: 0.01 }, "-=1");
	}
};

export default contactAnimation;
